angular.module('elfium').directive('companyList', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: elfiumUrlService.getTemplateUrl('company', 'companyList'),
        controller: 'companyListController'
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/company/companyList.ts